import { IEventCollectionDataActiveTypeticketcollections, IEventCollectionMetadata } from 'meta/pages/v4/eventCollection'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  collectionId: string
  page: number
}

type Response = { data: IEventCollectionDataActiveTypeticketcollections, metadata: IEventCollectionMetadata }

export const getActiveTypeticketcollections = async (props: Props): Promise<Response> => {
  const { collectionId, page } = props

  const endpoint = ApiEndpoint.v4.eventCollection.activeTypeticketcollections(collectionId, page)

  const { data, metadata } = await HttpRequestForApiV4.get<
    IEventCollectionDataActiveTypeticketcollections,
    IEventCollectionMetadata>(endpoint)
  
  return { data, metadata }
}
